import React, { useRef} from 'react';
import {Dialog} from "primereact/dialog";
import { useReactToPrint } from "react-to-print";
import {TablaDetalleInformeCompensacion} from "../../../Tables/TablaDetalleInformeCompensacion";
import {UseLoader} from "../../../../hooks/useLoader";

export const ModalDetalleInformeCompensacion = ({fields, show, hide}) => {

    const componentRef = useRef(null);
    const [handleLoad] = UseLoader();

    const handlePrint = useReactToPrint({
        documentTitle: "Informe Compensacion (Turnos por asociado factura)",
        content: () => componentRef.current,
        onBeforePrint: () => handleLoad(true),
        onAfterPrint: () => handleLoad(false),

    });

    const renderFooter = () => {
        return (
            <div className="flex align-items-center justify-end">
                <button
                    className="danger-color-btn btn"
                    type="button"
                    onClick={hide}
                >
                    cerrar
                </button>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    onClick={handlePrint}
                >
                    Imprimir
                </button>
            </div>

        );
    }

    return(
        <>
            <Dialog modal maximizable header="Informe Compensacion (Turnos por asociado factura)"
                    visible={show} style={{width: '90vw'}}
                    onHide={hide} footer={renderFooter}>
                <div className="container-relative ">
                    <TablaDetalleInformeCompensacion ref={componentRef} fieldsFactura={fields.data} fieldsAsociados={fields.dataAsociados} fieldsDataInicial={fields.dataInicial} />
                </div>

            </Dialog>
        </>
    )
}
